import { render } from "./ViewStudentClassRecordDialog.vue?vue&type=template&id=5acbab1b&scoped=true"
import script from "./ViewStudentClassRecordDialog.vue?vue&type=script&lang=js"
export * from "./ViewStudentClassRecordDialog.vue?vue&type=script&lang=js"

import "./ViewStudentClassRecordDialog.vue?vue&type=style&index=0&id=5acbab1b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acbab1b"]])

export default __exports__